// src/app/login/page.tsx
'use client';

import DashboardPage from '../../sections/dashboard/DashboardPage';


export default function DashboardPages() {
  return <DashboardPage />;
}